import { ChartLoadingIcon } from "./ChartLoadingIcon";

export default ChartLoadingIcon;
